export enum GridTypes {
  Apartments = 100,
  WaterMeters = 200,
  WaterSubscribers = 300,
  Users = 400,
}

/** Translation key for each grid's display name (used e.g. for export file names). */
export const GridTypeNameKeys: Record<GridTypes, string> = {
  [GridTypes.Apartments]: "apartments",
  [GridTypes.WaterMeters]: "meters",
  [GridTypes.WaterSubscribers]: "subscribers",
  [GridTypes.Users]: "users",
};
